import Papa from "papaparse";
import { Option } from "../../components/select/Select";

export const getNumber: (str: string | number) => number = str =>
  Number(String(str).replace(/[^\d.]/g, "")) || 0;

export const parseCSV: (file: File) => Promise<any[]> = file =>
  new Promise(resolve => {
    Papa.parse<File>(file, {
      complete: ({ data }) => resolve(data),
      worker: true,
      header: true
    });
  });

export const getOptionsFromArray: (strArray: string[] | number[]) => Option[] =
  strArray => {
    return strArray.map(str => ({ label: str, value: str }));
  };
